import { render } from "./adminhome.vue?vue&type=template&id=7ce2ac1e&scoped=true"
const script = {}

import "./adminhome.vue?vue&type=style&index=0&id=7ce2ac1e&scoped=true&lang=css"

import exportComponent from "D:\\HbSave\\roc_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ce2ac1e"]])

export default __exports__